//* Image Retry Controller
//*
//* Automatically retries loading a failed image.
//* - If online: retries after 2 seconds with a cache-busting param.
//* - If offline: waits for the browser to come back online, then retries.
//* - Hides the spinner target once the image loads.
import ApplicationController from "application_controller.js";

export default class extends ApplicationController {

  static targets = ["image", "spinner"];

  debug = false;

  connect() {
    this.log_function("connect", this.identifier);

    this.originalSrc = this.imageTarget.dataset.src || this.imageTarget.src;
    this.handleError = this.handleError.bind(this);
    this.handleRetry = this.handleRetry.bind(this);
    this.handleLoad = this.handleLoad.bind(this);
    this.imageTarget.addEventListener("error", this.handleError);
    this.imageTarget.addEventListener("load", this.handleLoad);

    //* If the image already loaded before the controller connected, hide spinner
    if (this.imageTarget.complete && this.imageTarget.naturalWidth > 0) {
      this.handleLoad();
    }
  }

  disconnect() {
    this.log_function("disconnect", this.identifier);

    this.imageTarget.removeEventListener("error", this.handleError);
    this.imageTarget.removeEventListener("load", this.handleLoad);
    window.removeEventListener("online", this.handleRetry);
  }

  handleLoad() {
    this.log_function("handleLoad");

    this.imageTarget.style.visibility = "";
    if (this.hasSpinnerTarget) {
      this.spinnerTarget.remove();
    }
  }

  handleError() {
    this.log_function("handleError", navigator.onLine ? "online" : "offline");

    this.imageTarget.style.visibility = "hidden";

    if (navigator.onLine) {
      setTimeout(() => this.handleRetry(), 2000);
    } else {
      window.addEventListener("online", this.handleRetry, { once: true });
    }
  }

  handleRetry() {
    this.log_function("handleRetry");

    const separator = this.originalSrc.includes("?") ? "&" : "?";
    const newSrc = `${this.originalSrc}${separator}_t=${Date.now()}`;
    this.log_function("handleRetry", newSrc);
    this.imageTarget.src = newSrc;
  }
}
